import Vue from 'vue'
import VueRouter from 'vue-router'

import TestLanding from '~/pages/TestLanding.vue'
import TestPush from '~/pages/TEST/TestPush.vue'
import TestPage from '~/pages/TestPage.vue'

import Home from '~/pages/index.vue'
import NotificationPage from '~/pages/user/NotificationPage.vue'
import CalendarPage from '~/pages/CalendarPage.vue'
import SavedAndWishlist from '~/pages/user/SavedAndWishlist.vue'

// import Error404 from '~/pages/Error404.vue'

// import Login from '~/pages/user/login.vue'
// import Register from '~/pages/user/register.vue'

import UserSettings from '~/pages/user/settings.vue'

import HostEditEvent from '~/pages/host/edit/event.vue'
// import HostEditLocation from '~/pages/host/edit/location.vue'

import ProfileMe from '~/pages/profile/me.vue'

import Events from '~/pages/events/index.vue'
import Locations from '~/pages/locations/index.vue'

import AuthenticationRegistrationRoutes from './registration'

import store from '~/store'

const About = () => import('~/pages/about.vue')
const Team = () => import('~/pages/team.vue')
const Dashboard = () => import('~/pages/dashboard.vue')
const EventSearch = () => import(/* webpackChunkName: "event-search" */ '~/pages/event-search.vue')

const HostInfo = () =>
	import(/* webpackChunkName: "host" */ '~/pages/host/apply/info.vue')
const HostApply = () =>
	import(/* webpackChunkName: "host" */ '~/pages/host/apply/apply.vue')
const HostSpaceInfo = () =>
	import(/* webpackChunkName: "host" */ '~/pages/host/apply/spaceinfo.vue')
const HostApplySuccess = () =>
	import(/* webpackChunkName: "host" */ '~/pages/host/apply/success.vue')
const HostApplicationProgress = () => 
	import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/apply/ApplicationProgress.vue')

const HostDashboard = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/index.vue')
const HostDashboardHome = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardHome.vue')
const HostDashboardEventDetails = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardEventDetails.vue')
const HostDashboardUpcomingEvents = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardUpcomingEvents.vue')
const HostDashboardPastEvents = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardPastEvents.vue')
const HostDashboardLocations = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardLocations.vue')
const HostDashboardLocationDetails = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardLocationDetails.vue')
const HostDashboardSettings = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardSettings.vue')
const HostDashboardFaq = () => import(/* webpackChunkName: "host_dashboard" */ '~/pages/host/dashboard/HostDashboardFaq.vue')

const HostApproveGuest = () =>
	import(/* webpackChunkName: "host-rsvp" */ '~/pages/host/rsvp/RsvpApproveGuest.vue')
const HostDenyGuest = () =>
	import(/* webpackChunkName: "host-rsvp" */ '~/pages/host/rsvp/RsvpDenyGuest.vue')

const HostAddEvent = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event.vue')
const HostAddEventIntro = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/start.vue')
const HostAddEventLocation = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/location.vue')
const HostAddEventType = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/type.vue')
const HostAddEventDescription = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/description.vue')
const HostAddEventFrequency = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/frequency.vue')
const HostAddEventSchedule = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/schedule.vue')
const HostAddEventFormat = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/format.vue')
const HostAddEventSeating = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/seating.vue')
const HostAddEventRestrictions = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/restrictions.vue')
const HostAddEventAmenities = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/amenities.vue')
const HostAddEventExtras = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/extras.vue')
const HostAddEventBring = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/bring.vue')
const HostAddEventNotes = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/notes.vue')
const HostAddEventSponsors = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/sponsors.vue')
const HostAddEventPhotos = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/photos.vue')
const HostAddEventSubmit = () =>
	import(/* webpackChunkName: "host-add-event" */ '~/pages/host/add/event_steps/submit.vue')

const HostAddLocation = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location.vue')
const HostAddLocationIntro = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/start.vue')
const HostAddLocationType = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/type.vue')
const HostAddLocationLocation = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/location.vue')
const HostAddLocationDescription = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/description.vue')
const HostAddLocationSeating = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/seating.vue')
const HostAddLocationAmenities = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/amenities.vue')
const HostAddLocationPhotos = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/photos.vue')
const HostAddLocationSubmit = () =>
	import(/* webpackChunkName: "host-add-location" */ '~/pages/host/add/location_steps/submit.vue')

// import ActiveEventPage from '~/pages/active_event/index.vue'

Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	base: __dirname,
	scrollBehavior(to, from, savedPosition) {
		if (!to.query.hasOwnProperty('modal')) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		}
	},
	routes: [
		...AuthenticationRegistrationRoutes,
		{
			path: '/',
			component: Home,
			name: 'root',
			meta: { requiresActiveIfAuth: true }
		},
		{
			path: '/asdf1234',
			component: TestPage,
			name: 'testpage',
		},
		{
			path: '/test-landing-5627',
			component: TestLanding,
			name: 'test',
		},
		{
			path: '/test-push-5627',
			component: TestPush,
			name: 'testpush',
		},
		{
			path: '/about',
			name: 'about',
			component: About
		},
		{
			path: '/team',
			name: 'team',
			component: Team,
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/messages',
			name: 'messages',
			component: NotificationPage,
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/saved',
			name: 'saved',
			component: SavedAndWishlist,
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/calendar',
			name: 'calendar',
			component: CalendarPage,
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/user/settings',
			name: 'user_settings',
			component: UserSettings,
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/dashboard',
			component: Dashboard,
			name: 'dashboard',
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/events',
			component: EventSearch,
			name: 'events',
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/host/add/location',
			component: HostAddLocation,
			meta: {
				requiresAuth: true,
				requireAuthVerify: true,
				redirectNonHost: true
			},
			children: [
				{
					path: '',
					name: 'host_add_location_intro',
					component: HostAddLocationIntro
				},
				{
					path: 'type',
					name: 'host_add_location_type',
					component: HostAddLocationType
				},
				{
					path: 'location',
					name: 'host_add_location_location',
					component: HostAddLocationLocation
				},
				{
					path: 'description',
					name: 'host_add_location_description',
					component: HostAddLocationDescription
				},
				{
					path: 'seating',
					name: 'host_add_location_seating',
					component: HostAddLocationSeating
				},
				{
					path: 'amenities',
					name: 'host_add_location_amenities',
					component: HostAddLocationAmenities
				},
				{
					path: 'photos',
					name: 'host_add_location_photos',
					component: HostAddLocationPhotos
				},
				{
					path: 'submit',
					name: 'host_add_location_submit',
					component: HostAddLocationSubmit
				}
			]
		},
		{
			path: '/host/add/event',
			component: HostAddEvent,
			meta: {
				requiresAuth: true,
				requireAuthVerify: true,
				requiresHost: true,
				redirectNonHost: true
			},
			children: [
				{
					path: '',
					name: 'host_add_event_intro',
					component: HostAddEventIntro
				},
				{
					path: 'location',
					name: 'host_add_event_location',
					component: HostAddEventLocation
				},
				{
					path: 'type',
					name: 'host_add_event_type',
					component: HostAddEventType
				},
				{
					path: 'description',
					name: 'host_add_event_description',
					component: HostAddEventDescription
				},
				{
					path: 'frequency',
					name: 'host_add_event_frequency',
					component: HostAddEventFrequency
				},
				{
					path: 'format',
					name: 'host_add_event_format',
					component: HostAddEventFormat
				},
				{
					path: 'seating',
					name: 'host_add_event_seating',
					component: HostAddEventSeating
				},
				{
					path: 'restrictions',
					name: 'host_add_event_restrictions',
					component: HostAddEventRestrictions
				},
				{
					path: 'amenities',
					name: 'host_add_event_amenities',
					component: HostAddEventAmenities
				},
				{
					path: 'extras',
					name: 'host_add_event_extras',
					component: HostAddEventExtras
				},
				{
					path: 'schedule',
					name: 'host_add_event_schedule',
					component: HostAddEventSchedule
				},
				{
					path: 'what-to-bring',
					name: 'host_add_event_bring',
					component: HostAddEventBring
				},
				{
					path: 'notes',
					name: 'host_add_event_notes',
					component: HostAddEventNotes
				},
				{
					path: 'sponsors',
					name: 'host_add_event_sponsors',
					component: HostAddEventSponsors
				},
				{
					path: 'photos',
					name: 'host_add_event_photos',
					component: HostAddEventPhotos
				},
				{
					path: 'submit',
					name: 'host_add_event_submit',
					component: HostAddEventSubmit
				}
			]
		},
		// {
		// 	path: '/host/add/location',
		// 	component: HostAddLocation,
		// 	name: 'host_add_location',
		// 	meta: { requiresAuth: true, requireAuthVerify: true }
		// },
		// {
		// 	path: '/host/edit/event/:slug',
		// 	component: HostEditEvent,
		// 	name: 'edit_event',
		// 	meta: { requiresAuth: true, requireAuthVerify: true }
		// },
		// {
		// 	path: '/host/edit/location/:id',
		// 	component: HostEditLocation,
		// 	name: 'edit_location',
		// 	meta: { requiresAuth: true, requireAuthVerify: true }
		// },
		{
			path: '/host/approve-guest/:guest_id/event/:event_slug/',
			component: HostApproveGuest,
			name: 'host_approve_guest',
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/host/deny-guest/:guest_id/event/:event_slug/',
			component: HostDenyGuest,
			name: 'host_deny_guest',
			meta: { requiresAuth: true, requireAuthVerify: true }
		},
		{
			path: '/host/info',
			component: HostInfo,
			name: 'host_info',
			meta: { requiresNotHost: true, redirectNonHost: true }
		},
		// {
		// 	path: '/host/info',
		// 	component: HostInfo,
		// 	name: 'host_info',
		// 	meta: { requiresAuth: true, requiresNotHost: true, redirectNonHost: true }
		// },
		{
			path: '/host/apply',
			component: HostApply,
			name: 'host_apply',
			meta: {
				requiresAuth: true,
				requiresNotHost: true,
				requireAuthVerify: true,
				redirectNonHost: true
			}
		},
		{
			path: '/host/apply/space',
			component: HostSpaceInfo,
			name: 'host_space',
			meta: { requiresAuth: true, requiresNotHost: true, redirectNonHost: true }
		},
		{
			path: '/host/apply/success',
			component: HostApplySuccess,
			name: 'host_apply_success',
			meta: { requiresAuth: true, requiresNotHost: true }
		},
		{
			path: '/host/progress',
			component: HostApplicationProgress,
			name: 'host_progress',
			meta: { requiredAuth: true, requiresNotHost: true, redirectNonHost: true }
		},
		{
			path: '/host/dashboard',
			component: HostDashboard,
			meta: {
				requiresAuth: true,
				requireAuthVerify: true,
				requiresHost: true
			},
			children: [
				{
					path: '',
					name: 'host_dashboard',
					component: HostDashboardHome
				},
				{
					path: 'events',
					name: 'host_dashboard_upcoming_events',
					component: HostDashboardUpcomingEvents,
				},
				{
					path: 'past_events',
					name: 'host_dashboard_past_events',
					component: HostDashboardPastEvents,
				},
				{
					path: 'event/:slug',
					name: 'host_dashboard_event_details',
					component: HostDashboardEventDetails,
				},
				{
					path: 'locations',
					name: 'host_dashboard_locations',
					component: HostDashboardLocations,
				},
				{
					path: 'location/:slug',
					name: 'host_dashboard_location_details',
					component: HostDashboardLocationDetails,
				},
				{
					path: 'faq',
					name: 'host_dashboard_faq',
					component: HostDashboardFaq,
				},
				{
					path: 'settings',
					name: 'host_dashboard_settings',
					component: HostDashboardSettings,
				}
			]
		},
		{
			path: '/profile/me',
			name: 'profile',
			component: ProfileMe,
			meta: { requiresAuth: true }
		},
		{
			path: '/events/:slug',
			name: 'event',
			component: Events,
			meta: { requiresAuth: true }
		},
		// {
		// 	path: '/active-event/:slug',
		// 	component: ActiveEventPage,
		// 	name: 'active_event',
		// 	meta: { requiresAuth: true }
		// },
		{
			path: '/@:slug',
			name: 'location',
			component: Locations,
			meta: { requiresAuth: true }
		},
		// {
		// 	path: '/\%40:slug',
		// 	name: 'location',
		// 	component: Locations,
		// 	meta: { requiresAuth: true }
		// },
		{
			path: '*',
			redirect: '/'
			// component: Error404
		}
	]
})
